export default __webpack_public_path__ + "static/activities_image_three-6770775916a6a5ff22a296493c929e6c.png";